import React from "react";
import { useTranslation } from "react-i18next";
import { Signifier } from "@activecollab/components";
import PropTypes from "prop-types";

const TaskObjectsCount = ({ iconType, count }) => {
  const { t } = useTranslation();

  const renderTooltipText = () => {
    switch (iconType?.displayName) {
      case `DependencySmallIcon`:
      case `DependencyIcon`:
        return t("Dependencies");
      case `MessageSmallIcon`:
      case `MessageIcon`:
        return t("Comments");
      default:
        return t("Subtasks");
    }
  };

  return (
    <Signifier
      value={count}
      type={iconType}
      tooltipText={renderTooltipText()}
    />
  );
};

TaskObjectsCount.propTypes = {
  iconType: PropTypes.object,
  count: PropTypes.number,
};

TaskObjectsCount.defaultProps = {
  iconType: {},
  count: 0,
};

TaskObjectsCount.displayName = `TaskObjectsCount`;

export default TaskObjectsCount;
